module.exports = require('crypto');


//////////////////
// WEBPACK FOOTER
// /home/travis/build/Pedro-vk/Bet-Token-wallet/node_modules/randomhex/src/crypto.js
// module id = TlyO
// module chunks = 0